<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 md4 class="http-code text-xs-center text-md-right" >
        {{response.status}}
      </v-flex>
      <v-flex xs12 md8 class="error-msg text-xs-center text-md-left">
        {{$tf(response.body.error)}}
      </v-flex>
      <v-flex xs12 class="action text-xs-center" >
        <v-btn to="/myspace" flat large>
          {{$tf('Go back to Idonia')}}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'http-error',
    props: {
      response: {
        type: Object,
        required: true
      }
    },
    created () {
      this.$store.dispatch('nav/fullView', true)
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    max-width: 1200px;
    overflow: hidden;
  }
  .layout {
    align-items: center;
  }
  .http-code {
    font-size: 10rem;
    font-weight: bold;
    background-color: #02648e;
    color: transparent;
    text-shadow: 2px 2px 2px rgba(255, 255, 255, 0.5);
    -webkit-background-clip: text;
    background-clip: text;
    text-align: right;
  }
  .error-msg {
    font-size: 4rem;
    padding: 2rem;
    font-weight: bold;
    text-align: left;
    color: #00638e;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
  }
  .action button {
    color: #00638e;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/HTTPError.vue